// extracted by mini-css-extract-plugin
export var root = "_zm-0";
export var scroll = "_zm-1";
export var thumb = "_zm-3";
export var track = "_zm-2";